import React from 'react';

import styled from '@emotion/styled';

import { SignInWallet } from '@web/features/login/SignInWallet';

import { HubTile } from '../HubTile';

import NoSignal from './no-signal.svg';

const UserHubTileNotConnectedContainer = styled(HubTile)`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.color.silver};
  padding: ${({ theme }) => theme.spacing('0500')};
  border-radius: ${({ theme }) => theme.shape.corner['2000']};
  gap: ${({ theme }) => theme.spacing('0500')};
  aspect-ratio: 1;
  height: auto;
`;

const VisualContainer = styled.div`
  overflow: hidden;
  border-radius: ${({ theme }) => theme.shape.corner['1500']};
  border: 1px solid ${({ theme }) => theme.color.onSilver};
  background: ${({ theme }) => theme.color.dark};
  flex: 1;
  aspect-ratio: 1;
  position: relative;
  :active {
    border-radius: ${({ theme }) => theme.shape.corner['2000']};
  }
`;

const ConnectContainer = styled.div`
  padding: ${({ theme }) => theme.spacing('1500')};
  flex-shrink: 0;
`;

const NoSignalSvgWrapper = styled.div`
  position: absolute;
  inset: 0;
  bottom: -2px;
  svg {
    width: 100%;
    height: 100%;
  }
`;

const NoSignalLabel = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: ${({ theme }) => theme.color.light};
  color: ${({ theme }) => theme.color.dark};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing('0500')};
  padding: ${({ theme }) => theme.spacing('0500')};
  font: ${({ theme }) => theme.typography.mono.regular};
  font-size: ${({ theme }) => theme.typescale.size['2']};
  pointer-events: auto;
  z-index: 2;
`;

export const UserHubTileNotConnected = () => {
  return (
    <UserHubTileNotConnectedContainer>
      <VisualContainer>
        <NoSignalSvgWrapper>
          <NoSignal />
        </NoSignalSvgWrapper>

        <NoSignalLabel>NO SIGNAL</NoSignalLabel>
      </VisualContainer>

      <ConnectContainer>
        <SignInWallet fullWidth />
      </ConnectContainer>
    </UserHubTileNotConnectedContainer>
  );
};
